import { parse, format, isValid } from 'date-fns';
import isString from 'lodash.isstring';

const short = (
	dateToFormat,
	hideIfInvalid = false,
	dateFormat = 'MM/dd/yyyy'
) => {
	let fromStringDate;
	if (isString(dateToFormat) && dateToFormat.length === 10) {
		fromStringDate = parse(dateToFormat, 'yyyy-MM-dd', new Date());
	} else {
		fromStringDate = new Date(dateToFormat);
	}
	if (isValid(fromStringDate)) {
		return format(fromStringDate, dateFormat);
	} else if (hideIfInvalid) {
		return '';
	} else {
		return dateToFormat;
	}
};

const long = (dateToFormat) => {
	const fromStringDate = new Date(dateToFormat);
	if (isValid(fromStringDate)) {
		return format(fromStringDate, 'PPpp');
	} else {
		return dateToFormat;
	}
};

const time = (dateToFormat) => {
	const fromStringDate = new Date(dateToFormat);
	if (isValid(fromStringDate)) {
		return format(fromStringDate, 'pp');
	} else {
		return dateToFormat;
	}
};

module.exports = {
	short,
	long,
	time,
};
